import Ajv, { ErrorObject } from 'ajv'
import schema from '../json-schema/home_information_jsonschema.json'

const ajv = new Ajv({ allErrors: true })
const validate = ajv.compile(schema)

/**
 * Validates the given data against the home information JSON schema.
 * @param data The props.data object to validate.
 * @returns {{ valid: boolean, errors: ErrorObject[] }}
 */
export async function validateHomeInformation(
    data: unknown,
): Promise<{ valid: boolean; errors: ErrorObject[] }> {
    const result = validate(data)
    const valid = typeof result === 'boolean' ? result : await result
    return {
        valid,
        errors: (validate.errors as ErrorObject[]) || [],
    }
}
